import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ResultsSection } from './components/ResultsSection';
import { SolutionSection } from './components/SolutionSection';
import { ModulesSection } from './components/ModulesSection';
import { BonusesSection } from './components/BonusesSection';
import { SuperBonusesSection } from './components/SuperBonusesSection';
import { CheckoutSection } from './components/CheckoutSection';
import { ForYouSection } from './components/ForYouSection';
import { OrderBump } from './components/OrderBump';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full bg-cream-50" data-id="element-0">
      <Hero data-id="element-1" />
      <PainSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <ResultsSection data-id="element-4" />
      <ModulesSection data-id="element-5" />
      <BonusesSection data-id="element-6" />
      <SuperBonusesSection data-id="element-7" />
      <ForYouSection data-id="element-8" />
      <OrderBump data-id="element-9" />
      <Testimonials data-id="element-10" />
      <CheckoutSection data-id="element-11" />
      <FAQ data-id="element-12" />
      <Guarantee data-id="element-13" />
      <Footer data-id="element-14" />
      <PurchasePopup data-id="element-15" />
    </div>;
}